import { Entity } from '@core/entities/entity'

import { plainToInstance, Type } from 'class-transformer'
import { TaskTemplatePriorityType } from '@core/entities/task/TaskTemplateProperties'
import { IInspectionTask } from '@core/entities/InspectionItemAnswer/IInspectionTask'
import { User } from '@core/entities/user'
import { TaskStatus } from '@core/entities/task/TaskBase'
import { InspectionTaskPermittedActions } from '@core/entities/InspectionItemAnswer/types'

export class InspectionTask extends Entity<IInspectionTask> {
  @Type(() => User)
  assignee: User

  @Type(() => User)
  createdBy: User

  createdOn: string

  // We cannot use TaskStep Entity here, as it causes a circular reference error in typescript
  currentStep: any

  id: number

  summary: string

  location?: string

  priority: TaskTemplatePriorityType

  dueDate: string

  status: TaskStatus

  modifiedOn: string

  // the template Entity also cannot be used here as it causes a circular reference error in typescript. Those are the only 2 fields used by the FE
  template?: {
    id: number
    name: string
  }

  permittedActions: InspectionTaskPermittedActions

  public static new(payload: unknown): InspectionTask {
    const entity = plainToInstance(InspectionTask, payload)

    return entity
  }
}
